import { IsDefined, Validate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ContractServiceTypeListDataService extends DataService<typeof Model.Products.Logic.ViewModels.ContractServiceTypeItem, Model.Products.Logic.ViewModels.ContractServiceTypeItem, ContractServiceTypeItem> {
    private id = -1;

    protected map(entity: Model.Products.Logic.ViewModels.ContractServiceTypeItem): ContractServiceTypeItem {
        return new ContractServiceTypeItemModel(entity);
    }

    static make(ctx?: any): ContractServiceTypeListDataService {
        return new ContractServiceTypeListDataService(ctx, ctx => ctx.ContractServiceTypes);
    }

    add(idContract: number) {
		const entity = new Model.Products.Logic.ViewModels.ContractServiceTypeItem();
		entity.contractId = idContract;
        entity.id = this.id--;

        return entity;
    }

    clone(contractServiceTypeItem: ContractServiceTypeItem) {
        const entity = new Model.Products.Logic.ViewModels.ContractServiceTypeItem();
        entity.contractId = contractServiceTypeItem.contractId;
        entity.productServiceTypeId = contractServiceTypeItem.productServiceTypeId;
        entity.productServiceTypeDisplayName = contractServiceTypeItem.productServiceTypeDisplayName;
        entity.id = this.id--;
		entity.id = (contractServiceTypeItem.id > 0) ? contractServiceTypeItem.id * -1 : contractServiceTypeItem.id - 100;

        return entity;
    }
}

export class ContractServiceTypeItemModel extends EntityModel<Model.Products.Logic.ViewModels.ContractServiceTypeItem, ContractServiceTypeItem> implements ContractServiceTypeItem {
    @property<ContractServiceTypeItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<ContractServiceTypeItemModel>(o => o.entity.contractId, (o, value) => o.entity.contractId = value)
	public contractId: number;

    @IsDefined({ message: 'product service is required' })
    @property<ContractServiceTypeItemModel>(o => o.entity.productServiceTypeId, (o, value) => o.entity.productServiceTypeId = value)
    public productServiceTypeId: number;

    @property<ContractServiceTypeItemModel>(o => o.entity.productServiceTypeDisplayName, (o, value) => o.entity.productServiceTypeDisplayName = value)
    public productServiceTypeDisplayName: string;
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/contract-service-type-list.data.ts